import ApiException from "@rmp/core/exceptions/apiException";

/**
 * Ошибка, для которой сервер вернул тело в формате Problem Details (RFC 7807).
 * В отличие от остальных ошибок запроса, содержит текст, пригодный для показа пользователю.
 */
export default class ProblemDetailsException extends ApiException {
	title: string;
	detail: string;
	
	constructor(title: string, detail = "") {
		super(detail || title);
		
		this.title = title;
		this.detail = detail;
	}
	
	get displayMessage(): string {
		return this.detail || this.title;
	}
}
